// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ApprovalDetailsContainer_wrap__cjAIH","title":"ApprovalDetailsContainer_title__3zMIG","details":"ApprovalDetailsContainer_details__15fJH"};